"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CommunicationInstanceAllStatus;
(function (CommunicationInstanceAllStatus) {
    CommunicationInstanceAllStatus["Created"] = "Created";
    CommunicationInstanceAllStatus["Mailed"] = "Mailed";
    CommunicationInstanceAllStatus["Processed"] = "Processed";
    CommunicationInstanceAllStatus["ProcessError"] = "ProcessError";
    CommunicationInstanceAllStatus["Queued"] = "Queued";
    CommunicationInstanceAllStatus["QueueError"] = "QueueError";
    CommunicationInstanceAllStatus["Delivered"] = "Delivered";
    CommunicationInstanceAllStatus["Bounced"] = "Bounced";
    CommunicationInstanceAllStatus["Opened"] = "Opened";
    CommunicationInstanceAllStatus["Sent"] = "Sent";
    CommunicationInstanceAllStatus["SendError"] = "SendError";
    CommunicationInstanceAllStatus["InLocalArea"] = "In Local Area";
    CommunicationInstanceAllStatus["InTransit"] = "In-Transit";
    CommunicationInstanceAllStatus["OutForDelivery"] = "Out for Delivery";
    CommunicationInstanceAllStatus["ReRouted"] = "Re-routed";
    CommunicationInstanceAllStatus["ReturnedToSender"] = "Returned to Sender";
    CommunicationInstanceAllStatus["Printed"] = "Printed";
    CommunicationInstanceAllStatus["Issue"] = "Issue";
    CommunicationInstanceAllStatus["ProcessedForDelivery"] = "Processed for Delivery";
    CommunicationInstanceAllStatus["PickupAvailable"] = "Available for Pickup";
})(CommunicationInstanceAllStatus = exports.CommunicationInstanceAllStatus || (exports.CommunicationInstanceAllStatus = {}));
//# sourceMappingURL=CommunicationInstanceAllStatus.js.map